import { render, staticRenderFns } from "./InPendingArticlesAndOrders.vue?vue&type=template&id=25aed338&scoped=true"
import script from "./InPendingArticlesAndOrders.vue?vue&type=script&lang=js"
export * from "./InPendingArticlesAndOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aed338",
  null
  
)

export default component.exports